import tr from './turkish.json';
import en from './english.json';
const languages = {
  tr,
  en,
};

export default languages;
